module.exports = __webpack_public_path__ + "img/lotery-rewards-1.f1533f4e.jpg";